import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { ACCESS_TOKEN, CHECK_OWNER_SHOP } from '../../commons/constants';
import { inject, observer } from 'mobx-react';

@inject('appStore')
@observer
class Route extends React.Component {
  render() {
    const { layout: Layout, component: Com, isAuthenticate } = this.props;
    const accessToken = localStorage.getItem(ACCESS_TOKEN);

    if (isAuthenticate) {
      const url = this.props.location.pathname;
      this.props.appStore.Url.setUrl(url);

      // Missing/empty token: redirect and DO NOT mount protected page
      // (mounting would fire APIs with Bearer null → 401 → logout loop).
      if (!accessToken) {
        const pathname = CHECK_OWNER_SHOP ? '/login-owner-shop' : '/';
        return (
          <Redirect
            to={{
              pathname,
              search: this.props.location.search,
              state: { modal: true, from: url },
            }}
          />
        );
      }
    }

    if (Layout) {
      return (
        <Layout>
          <Com {...this.props} />
        </Layout>
      );
    }

    return <Com {...this.props} />;
  }
}

export default withRouter(Route);
